var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.printers,"size":"sm"},on:{"change":_vm.savePrinter},model:{value:(_vm.printer),callback:function ($$v) {_vm.printer=$$v},expression:"printer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }